function initCardBuy() {
  try {
		
  } catch {
  }
}
